function initCardBuy() {
  try {
		
  } catch {
  }
}
